import Text from "atoms/Text";
import { useEffect, useRef, useState } from "react";
import useAvlReportToolTip from 'store/avlReportTooltipStore';

const AllocationErrorTooltip = ({ tooltip }) => {
  const tooltipRef = useRef(null);
  const [adjustedLeft, setAdjustedLeft] = useState(tooltip.pos.x - 10);
  const [alignRight, setAlignRight] = useState(false);
  const { hideErrorTooltip } = useAvlReportToolTip();

  useEffect(() => {
    if (tooltipRef.current) {
      const rect = tooltipRef.current.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      if (rect.right > windowWidth) {
        setAdjustedLeft(tooltip.pos.x - (rect.width - 14));
        setAlignRight(true);
      } else {
        setAdjustedLeft(tooltip.pos.x - 10);
        setAlignRight(false);
      }
    }
  }, [tooltip.pos.x]);

  return (
    <div
      ref={tooltipRef}
      className="fixed bg-red-50 border border-red-300 z-10 shadow-tooltip max-w-[390px] w-full"
      style={{ left: adjustedLeft, top: tooltip.pos.y - 70 }}
    >
      <div className={`absolute w-2.5 h-2.5 transform rotate-45 -bottom-[5px] ${alignRight ? 'right-2' : 'left-2'} bg-red-50 shadow-tooltip border border-red-300`} />

      <div className="flex justify-between">
        <div className="bg-red-50 p-2 flex flex-col gap-y-1 relative">
          {Array.isArray(tooltip.data.errorMessage) ? (
            tooltip.data.errorMessage.map(({ msg, buttonLabel, onClick }, idx) => (
              <div key={idx} className="flex items-center gap-1">
                <svg className='shrink-0' width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M9 14C11.7614 14 14 11.7614 14 9C14 6.23858 11.7614 4 9 4C6.23858 4 4 6.23858 4 9C4 11.7614 6.23858 14 9 14Z" stroke="#DA291C" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9 11V9" stroke="#DA291C" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9 7H9.005" stroke="#DA291C" strokeLinecap="round" strokeLinejoin="round" />
                </svg>

                <Text variant="labelSmall" color="text-red-600" >
                  {msg}
                  <span onClick={onClick} className="text-green-900 whitespace-nowrap ml-2 cursor-pointer" >
                    {buttonLabel}
                  </span>
                </Text>
              </div>
            ))
          ) : (
            <div className="flex items-center gap-1">
              <svg className='shrink-0' width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M9 14C11.7614 14 14 11.7614 14 9C14 6.23858 11.7614 4 9 4C6.23858 4 4 6.23858 4 9C4 11.7614 6.23858 14 9 14Z" stroke="#DA291C" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 11V9" stroke="#DA291C" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M9 7H9.005" stroke="#DA291C" strokeLinecap="round" strokeLinejoin="round" />
              </svg>

              <Text variant="labelSmall" color="text-red-600" >
                {tooltip.data.errorMessage}
                <span className="text-green-900 whitespace-nowrap ml-2 cursor-pointer">
                  Add Shift
                </span>
              </Text>
            </div>
          )}
        </div>
        <svg
          className="shrink-0 m-2 cursor-pointer"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          onClick={hideErrorTooltip}
        >
          <path
            d="M6 6L12 12"
            stroke="#DA291C"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 6L6 12"
            stroke="#DA291C"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    </div>
  );
};

export default AllocationErrorTooltip;


